import { useAuthenticatedUser } from 'features/authentication';

export const useFilterStorageKey = (section: string) => {
  const user = useAuthenticatedUser();
  return `${user.id}-filter-${section}`;
};
